<template>
  <div class="profile-container container">
    <div class="profile-portrait">
      <div class="profile-portrait-container">
      <figure>
        <img src="../../assets/images/farina_cahm.jpg" alt="Farina Cahm" >
          </figure>
         <div class="finger-print"><img class="" src="@/assets/images/fingerprints/fingerprint-four.svg" alt=""></div>
      </div>
    </div>
    <div class="profile-statement">

      <h2>Farina Cahm</h2>

      <p class="job-title">Assistant Careers Adviser</p>

        <p class="profile-statement-interviewer">Tell us a little bit about yourself</p>

        <p>I’m a 48-year-old British born Pakistani (some may consider of mixed heritage as my Mum was from Bangalore, South India and my dad from Lahore, Pakistan) I was born and brought up in Manchester. After moving away to study and live, I’m settled in Warrington, living with my husband and daughter. I have kept at the heart of the way I live my life, the values of my childhood, being a proud Pakistani Muslim and engaging with my peers and friends - even if they have had a different upbringing or cultural experience to me. I like to consider myself a good ambassador of multiculturalism.</p>

        <p class="profile-statement-interviewer">What inspires you within your role? </p>

        <p>Being able to support students and faculty colleagues and, hopefully, be a small, positive part of a student’s career journey. I love being part of a university and Careers Service that offers so many diverse opportunities for all students. Also, being in a supportive team who are open, enthusiastic, and willing to share ideas to support colleagues and students</p>

        <p class="profile-statement-interviewer">What is something that you love about your culture or heritage?</p>

        <p>The love of food and sharing that love. To me, the month of Ramadan in particular (which has become a more symbolic and an important month for me in recent years) and (pre Covid) being able to invite friends and family to the iftar meal to break the fast either in my home or in a mosque setting. Sharing food hopefully helps to promote community cohesion, conversation and understanding. I also love the amazing Henna art that often aligns with a lot of our cultural celebrations, such as weddings.</p>

        <p class="profile-statement-interviewer">What does it look like to bring your whole self to your work?</p>

        <p>A positive enthusiastic member of staff who is open to sharing and celebrating my diversity, life experiences and individuality with staff and students, and, in so doing hopefully encouraging others to do the same.</p>

        <p class="profile-statement-interviewer">How do you think MMU can best celebrate their Black, Asian, and Ethnic Minority staff and students?</p>

        <p>By showcasing their work and contributions to the university whether big or small. From acknowledging the small wins and applauding the big wins too. MMU is a diverse exciting university where all students and staff should feel like they belong. Open conversations about how to make the university a safe cohesive unit will hopefully work if we are open to talking together, and having conversations where we can appreciate and acknowledge our differences as individuals, whilst working together to promote a cohesive community in the university.</p>

        <p class="profile-statement-interviewer">What are you most proud of? </p>

        <p>Aside from becoming a mother, which was for a landmark moment in my life, I properly learnt to swim aged 40. A couple of years later, I completed my first ever triathlon. I then had my story and <a target="blank" href="https://www.britishtriathlon.org/news/farina-cahm-–-helping-us-to-celebrate-women’s-sport-week_7461">my journey featured on the British Triathlon website</a>. I was super proud of the moment I crossed the finish line, and the article on the website was just the icing on the cake.</p>

    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

  // .profile-container {
  // flex-direction: row-reverse;
  // }

  .profile-portrait-container {
    justify-content: flex-start;

    & figure {
      text-align: left;
    }
  }

  // .profile-statement {
  //   padding-right: 5rem;
  //   // padding-left: 5rem;
  // }

</style>